import { TableState } from '@tanstack/table-core';
import { useAppSelector } from 'src/hooks';
import CollapsibleTable from 'src/components/collapsible-table/collapsible-table';
import { makeDataForTable, getDataForEditedSimulatedRows } from 'src/components/collapsible-table/table-data-prep';
import {
  MODIFIED_ROW_INDICATOR_KEY,
} from '../../../pricing-simulator/types/generic-table.model';

export default function DelistTableComponent({ columns }: { columns: any }) {
  const { tableMetadaData, outputColumnVisibilityState, isSKUEditedClick } = useAppSelector((state) => state.table);

  const tableState: Partial<TableState> = {
    columnVisibility: outputColumnVisibilityState
  };

  const getRows = (tableRows) => {
    if (isSKUEditedClick) {
      return makeDataForTable(
        getDataForEditedSimulatedRows(
          tableMetadaData,
          MODIFIED_ROW_INDICATOR_KEY.DELIST_IS_EDITED,
          MODIFIED_ROW_INDICATOR_KEY.DELIST_IS_NOT_DEFAULT,
          MODIFIED_ROW_INDICATOR_KEY.DELIST_IS_USER_INPUT
        )
      ).sort((p1, p2) => (p1.sku > p2.sku ? 1 : p1.sku < p2.sku ? -1 : 0));
    }
    return tableRows;
  };

  // Rendering table component data
  return (
    <CollapsibleTable
      data={getRows(makeDataForTable(tableMetadaData.row))}
      setHeightExplicitly
      columns={columns}
      tableState={tableState}
    />
  );
}
